module.exports = __webpack_public_path__ + "static/media/compost.1e9e2462.svg";